import React from "react";

const UnderConstruction = () => {
  return (
    <div>UnderConstruction</div>)
}

export default UnderConstruction;